import { useState, useEffect } from "react";
import { Link } from "react-scroll";

const sections = [
  { id: "heroSection", label: "Home" },
  { id: "MyPortfolio", label: "Portfolio" },
  { id: "mySkills", label: "Skills" },
  { id: "Certificates", label: "Certificates" },
  { id: "AboutMe", label: "About" },
  { id: "Contact", label: "Contact" },
];

export default function NavDots() {
  const [active, setActive] = useState("heroSection");

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      },
      { rootMargin: "-50% 0px -50% 0px" }
    );

    sections.forEach(({ id }) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <div className="fixed right-6 top-1/2 -translate-y-1/2 z-40 hidden lg:flex flex-col gap-4">
      {sections.map(({ id, label }) => (
        <Link
          key={id}
          to={id}
          spy={true}
          smooth={true}
          offset={-80}
          duration={500}
          className="group relative flex items-center justify-center"
          aria-label={label}
        >
          <span
            className={`block w-2.5 h-2.5 rounded-full transition-all duration-300 cursor-pointer
              ${
                active === id
                  ? "bg-black dark:bg-white scale-125"
                  : "bg-black/20 dark:bg-white/20 hover:bg-black/40 dark:hover:bg-white/40"
              }`}
          />
          <span className="absolute right-full mr-3 px-2 py-1 rounded-lg bg-black dark:bg-white text-white dark:text-black
                           text-xs font-body font-medium opacity-0 group-hover:opacity-100 transition-opacity
                           pointer-events-none whitespace-nowrap">
            {label}
          </span>
        </Link>
      ))}
    </div>
  );
}
